// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"d10aed88","513":"1f137630","703":"8c050abd"}[chunkId] + ".chunk.js";
};